import { 
    apiRequest,
    cutiApproveRekove
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class DetailRepository {

    fetchRevoke = async (query) => {
        return await apiRequest("post", cutiApproveRekove, {
            body: query
        }, true)
    }

}

export default DetailRepository